import { useRef, useState } from "react";
import { Header } from "../../widgets";
import { Loader } from "../../widgets/loaders/Loader";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { classNames } from "primereact/utils";
import { getItemLocalStorage } from "../../features/webStorageSaver";
import ToastMessageContainer from "../../widgets/toastMessageContainer/ToastMessageContainer";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../stateManagement/reducers";

const eyeIcon = require('../../assets/images/fontAwesomeIcons/eye-solid.svg').default
const eyeSlashIcon = require('../../assets/images/fontAwesomeIcons/eye-slash-solid.svg').default

// Страница для восстановления пароля
export function ResetPasswordPage() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { dataBase, guid }: any = useParams()
    // определения из библиотеки react-hook-form
    const {
        register,
        handleSubmit,
        watch,
        formState: {
            errors,
            isSubmitting,
        }
    }: any = useForm({
        // начальные значения для формы
        defaultValues: {
            "newPassword": "",
            "newPasswordRepeat": ""
        }
    });

    const errRef = useRef<HTMLInputElement>()
    const [loading, setLoading] = useState<any>();
    const [isSuccess, setIsSuccess] = useState<boolean>(false)
    const [passwordIsShown, setPasswordIsShown] = useState<boolean>(false)

    // обработчик для кнопки "Вход"
    async function onSubmit(data: { newPassword: any, newPasswordRepeat: string }) {
        setLoading(true)
        const fullConfig = getItemLocalStorage('fullConfig')
        const currentConfig = fullConfig[dataBase]
        let apiUrl = currentConfig?.irosRestApiUrl
        let newPassword = data.newPassword
        try {
            const url = `${apiUrl}/security/account/changePassword?guid=${guid}&NewPassword='${newPassword}'`;
            const response = await axios.get(url);
            const data = response.data;
            if (data.value) {
                setIsSuccess(true)
                setLoading(false)
            } else if (data.Error === 'link not found') {
                setIsSuccess(false)
                setLoading(false)
                dispatch(showToastMessage({ messageText: 'Истекло время действия ссылки для смены пароля', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            } else if (data.Error === 'User not enabled') {
                setIsSuccess(false)
                setLoading(false)
                dispatch(showToastMessage({ messageText: 'Регистрация пользователя еще не была подтверждена', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
        } catch (error: any) {
            if (error?.response?.status !== 502 && error?.response?.data?.error?.code !== 'Forbidden') {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({ messageText: 'Проблемы с соединением', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
            setIsSuccess(false)
            setLoading(false)
        }
    }

    function passwordEyeClick() {
        setPasswordIsShown(!passwordIsShown)
    }

    let passwordIconClassName = classNames({
        "eye-password": passwordIsShown,
        "slash-eye-password": !passwordIsShown
    })

    return (
        <>
            {loading ? <Loader /> : <></>}
            <div>
                <ToastMessageContainer position="bottom-center" />
                <Header type="login" />
                <div className="login-page-back">
                    <div>
                        <div className="login-window remind">
                            <div className="login-window-top">
                                Смена пароля
                            </div>
                            <div className="login-window-main">
                                {!isSuccess
                                    ?
                                    <form onSubmit={handleSubmit(onSubmit)} >
                                        <div>
                                            <label className="d-flex flex-column">
                                                <span>Новый пароль (не менее 8 символов)</span>
                                                {/* Поле для ввода нового пароля */}
                                                <div className="d-flex">
                                                    <input
                                                        {...register("newPassword", {
                                                            required: "Введите новый пароль.",
                                                            minLength: {
                                                                value: 8,
                                                                message: "Длина пароля должна быть 8 символов и более",
                                                            },
                                                        })}
                                                        className="new-password-input"
                                                        aria-invalid={errors["newPassword"]}
                                                        placeholder="Введите новый пароль..."
                                                        type={passwordIsShown ? "text" : "password"}
                                                    />
                                                    <div onClick={passwordEyeClick} className="password-eye-button">
                                                        <img className={passwordIconClassName} src={passwordIsShown ? eyeIcon : eyeSlashIcon} />
                                                    </div>
                                                </div>
                                            </label>
                                            {errors["newPassword"] && <p role="alert">{errors["newPassword"]?.message}</p>}
                                        </div>
                                        <div>
                                            <label className="d-flex flex-column">
                                                <span>Новый пароль повторно</span>
                                                {/* Поле для повторного ввода нового пароля */}
                                                <input
                                                    {...register("newPasswordRepeat", {
                                                        required: "Введите новый пароль повторно.",
                                                        validate: (val: string) => {
                                                            if (watch('newPassword') != val) {
                                                                return "Пароли не совпадают";
                                                            }
                                                        },
                                                    })}
                                                    aria-invalid={errors["newPasswordRepeat"]}
                                                    placeholder="Введите новый пароль повторно..."
                                                    type={passwordIsShown ? "text" : "password"}
                                                />
                                            </label>
                                            {errors["newPasswordRepeat"] && <p role="alert">{errors["newPasswordRepeat"]?.message}</p>}
                                        </div>
                                        <button disabled={isSubmitting}>Сохранить пароль</button>
                                    </form>
                                    :
                                    <div>
                                        <span className="success-message">Пароль успешно изменен.</span>
                                        <button onClick={() => navigate('/')} className="back-to-main-but">На главную</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
